<style scoped>
  .btn-group {
    padding-left: 20px;
  }
</style>
<template>
  <div class="knowledge_query">
    <RadioGroup size="large" v-model="activeBtn" type="button" style="margin-bottom: 20px;">
      <Radio label="propInfo">产权列表</Radio>
      <Radio label="shopInfo">商铺列表</Radio>
    </RadioGroup>
    <Card>
      <prop-info v-show="activeBtn=='propInfo'"></prop-info>
      <shop-info v-if="activeBtn=='shopInfo'"></shop-info>
    </Card>
  </div>
</template>
<script>
  import propInfo from "./component/prop-info.vue";
  import shopInfo from "./component/shop-info.vue";
  export default {
    name:'shopMain_page',
    data() {
      return{
        activeBtn:'propInfo'
      }
    },
    components: {
      propInfo,
      shopInfo
    },
    methods:{

    }
  }
</script>






